import { Box } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import AggregateCellRenderer from "./AggregateCellRenderer";
import "./Renderers.css";

export interface IStandardCellRendererParams extends ICellRendererParams {
    cellDataGetter(params: IStandardCellRendererParams): StandardCellData;
}

export type StandardCellData = {
    displayText?: string;       // required for all columns
    dataValue?: number;         // required for numeric column
    timestamp?: string | Date;  // required for timestamp column
    href?: string;
};

export default function StandardCellRenderer(params: IStandardCellRendererParams) {
    const cellData = params.cellDataGetter(params);
    const isAggregateRow = params.node.group; // Footer or group aggregate row

    return (
        isAggregateRow
            ? <AggregateCellRenderer {...params} />
            : <Box
                className="ag-cell-value"
                sx={{
                    cursor: 'pointer'
                }}
            >
                {cellData?.displayText}
            </Box>
    )
}
